@switch (policyKind()) {
  @case ('terms') {
    <div class="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
      <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

        <!-- Header -->
        <div class="text-center mb-12">
          <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">Terms of Service</h1>
          <p class="text-lg text-gray-600 dark:text-gray-400">Last updated: {{ lastUpdated() }}</p>
        </div>

        <!-- Content -->
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 space-y-8">

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">1. Introduction</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              Welcome to Wall St Yardie Inc ("we," "our," or "us"). These Terms of Service ("Terms") govern your use of our website,
              mobile application, and services (collectively, the "Service") operated by Wall St Yardie Inc.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mt-4">
              By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of these terms,
              then you may not access the Service.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">2. Acceptance of Terms</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              By accessing and using Wall St Yardie Inc, you accept and agree to be bound by the terms and provision of this agreement.
              Additionally, when using this website's particular services, you shall be subject to any posted guidelines or rules
              applicable to such services.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">3. Use License</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              Permission is granted to temporarily download one copy of the materials on Wall St Yardie Inc's website for personal,
              non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
              <li>modify or copy the materials</li>
              <li>use the materials for any commercial purpose or for any public display</li>
              <li>attempt to reverse engineer any software contained on the website</li>
              <li>remove any copyright or other proprietary notations from the materials</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">4. Investment Information Disclaimer</h2>
            <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
              <div class="flex">
                <div class="flex-shrink-0">
                  <i class="pi pi-exclamation-triangle text-yellow-400"></i>
                </div>
                <div class="ml-3">
                  <p class="text-sm text-yellow-700 font-semibold">
                    IMPORTANT: The information provided on Wall St Yardie Inc is for educational and informational purposes only.
                  </p>
                </div>
              </div>
            </div>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              <strong>NOT INVESTMENT ADVICE:</strong> Nothing on this website constitutes investment advice, performance data,
              or any recommendation that any particular security, portfolio of securities, transaction, or investment strategy
              is suitable for any specific person.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              <strong>NO BUY RECOMMENDATIONS:</strong> Wall St Yardie Inc does not provide buy, sell, or hold recommendations.
              All analysis, prices, and opinions shared are our personal views and should not be interpreted as investment advice.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              <strong>EDUCATIONAL PURPOSE:</strong> All information, strategies, and analysis shared are for educational purposes only.
              You should consult with a qualified financial advisor before making any investment decisions.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">5. User Accounts</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              When you create an account with us, you must provide information that is accurate, complete, and current at all times.
              You are responsible for safeguarding the password and for all activities that occur under your account.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of
              any breach of security or unauthorized use of your account.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">6. Prohibited Uses</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">You may not use our Service:</p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
              <li>For any unlawful purpose or to solicit others to perform unlawful acts</li>
              <li>To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances</li>
              <li>To infringe upon or violate our intellectual property rights or the intellectual property rights of others</li>
              <li>To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate</li>
              <li>To submit false or misleading information</li>
              <li>To upload or transmit viruses or any other type of malicious code</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">7. Content</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics,
              videos, or other material ("Content"). You are responsible for Content that you post to the Service, including its
              legality, reliability, and appropriateness.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              By posting Content to the Service, You grant us the right and license to use, modify, publicly perform, publicly display,
              reproduce, and distribute such Content on and through the Service.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">8. Privacy Policy</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service,
              to understand our practices.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">9. Termination</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability,
              under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">10. Disclaimer</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              The information on this website is provided on an "as is" basis. To the fullest extent permitted by law, this Company:
            </p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4 mt-4">
              <li>excludes all representations and warranties relating to this website and its contents</li>
              <li>excludes all liability for damages arising out of or in connection with your use of this website</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">11. Limitations</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              In no event shall Wall St Yardie Inc or its suppliers be liable for any damages (including, without limitation, damages for
              loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on
              Wall St Yardie Inc's website, even if Wall St Yardie Inc or a Wall St Yardie Inc authorized representative has been notified orally
              or in writing of the possibility of such damage.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">12. Governing Law</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              These terms and conditions are governed by and construed in accordance with the laws of the United States and you
              irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">13. Changes to Terms</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material,
              we will try to provide at least 30 days notice prior to any new terms taking effect.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">14. Contact Information</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <div class="mt-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-gray-700 dark:text-gray-300"><strong>Email:</strong> bossman&#64;wallstyardie.com</p>
              <p class="text-gray-700 dark:text-gray-300"><strong>Website:</strong> www.wallstyardie.com</p>
            </div>
          </section>

        </div>

        <div class="text-center mt-8">
          <a href="/" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 transition-colors">
            <i class="pi pi-arrow-left mr-2"></i>Back to Home
          </a>
        </div>

      </div>
    </div>
  }

  @case ('privacy') {
    <div class="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
      <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

        <div class="text-center mb-12">
          <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">Privacy Policy</h1>
          <p class="text-lg text-gray-600 dark:text-gray-400">Last updated: {{ lastUpdated() }}</p>
        </div>

        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 space-y-8">

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">1. Introduction</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              Wall St Yardie Inc ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect,
              use, disclose, and safeguard your information when you visit our website and use our services.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mt-4">
              Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access the site.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">2. Information We Collect</h2>
            <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Personal Information</h3>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">We may collect personal information that you voluntarily provide to us when you:</p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4 mb-6">
              <li>Register for an account</li>
              <li>Subscribe to our newsletter</li>
              <li>Contact us directly</li>
              <li>Participate in surveys or promotions</li>
            </ul>
            <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Automatically Collected Information</h3>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              When you visit our website, we may automatically collect certain information about your device, including:
            </p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Referring website</li>
              <li>Pages viewed and time spent on pages</li>
              <li>Date and time of visits</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">3. How We Use Your Information</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">We may use the information we collect about you to:</p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
              <li>Provide, operate, and maintain our services</li>
              <li>Improve, personalize, and expand our services</li>
              <li>Understand and analyze how you use our services</li>
              <li>Develop new products, services, features, and functionality</li>
              <li>Communicate with you for customer service and support</li>
              <li>Send you marketing and promotional communications (with your consent)</li>
              <li>Process transactions and send related information</li>
              <li>Find and prevent fraud and security issues</li>
            </ul>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">4. How We Share Your Information</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except in the following circumstances:
            </p>
            <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Service Providers</h3>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              We may share your information with third-party service providers who perform services on our behalf, such as:
            </p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4 mb-6">
              <li>Website hosting and maintenance</li>
              <li>Email delivery services</li>
              <li>Analytics providers</li>
              <li>Payment processors</li>
            </ul>
            <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Legal Requirements</h3>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              We may disclose your information if required to do so by law or in response to valid requests by public authorities.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">5. Data Security</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access,
              alteration, disclosure, or destruction. These measures include:
            </p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4">
              <li>Encryption of data in transit and at rest</li>
              <li>Regular security assessments</li>
              <li>Access controls and authentication</li>
              <li>Employee training on data protection</li>
            </ul>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mt-4">
              However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">6. Cookies and Tracking Technologies</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              We use cookies and similar tracking technologies to enhance your experience on our website. Cookies are small data files stored on your device.
            </p>
            <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Types of Cookies We Use:</h3>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4 mb-4">
              <li><strong>Essential Cookies:</strong> Necessary for the website to function properly</li>
              <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our website</li>
              <li><strong>Functional Cookies:</strong> Remember your preferences and settings</li>
              <li><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements</li>
            </ul>
            <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Authentication Cookies (Auth0):</h3>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
              We use Auth0, a third-party authentication service, to manage user login and authentication. Auth0 sets the following cookies to maintain your login session:
            </p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4 mb-4">
              <li><strong>auth0:</strong> Session cookie that stores your authentication state and allows you to remain logged in</li>
              <li><strong>auth0_compat:</strong> Compatibility cookie for legacy browser support</li>
              <li><strong>did:</strong> Device identifier cookie used for security and fraud prevention</li>
              <li><strong>did_compat:</strong> Compatibility version of the device identifier cookie</li>
            </ul>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              These cookies are essential for authentication and cannot be disabled if you wish to use our services. They are automatically deleted when you log out or after your session expires.
              Auth0 cookies are set on the domain <strong>login.wallstyardie.com</strong> and are used solely for authentication purposes.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              For more information about Auth0's privacy practices and cookie usage, please visit
              <a href="https://auth0.com/privacy" target="_blank" rel="noopener noreferrer" class="text-green-600 hover:text-green-700 underline">Auth0's Privacy Policy</a>.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              You can control non-essential cookies through your browser settings. However, disabling certain cookies may affect the functionality of our website.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">7. Third-Party Services</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              Our website may contain links to third-party websites or integrate with third-party services. We are not responsible for the privacy practices
              of these third parties. We encourage you to read their privacy policies.
            </p>
            <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Third-Party Services We Use:</h3>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-3 ml-4 mb-4">
              <li>
                <strong>Auth0:</strong> Authentication and identity management service. Auth0 processes your login credentials and maintains your session.
                <a href="https://auth0.com/privacy" target="_blank" rel="noopener noreferrer" class="text-green-600 hover:text-green-700 underline">Auth0 Privacy Policy</a>
              </li>
              <li>
                <strong>Stripe:</strong> Payment processing for subscriptions and transactions. Stripe handles all payment card information securely.
                <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" class="text-green-600 hover:text-green-700 underline">Stripe Privacy Policy</a>
              </li>
              <li>
                <strong>Brevo (formerly Sendinblue):</strong> Email service provider for transactional and marketing emails.
                <a href="https://www.brevo.com/legal/privacypolicy/" target="_blank" rel="noopener noreferrer" class="text-green-600 hover:text-green-700 underline">Brevo Privacy Policy</a>
              </li>
              <li>
                <strong>Microsoft Azure:</strong> Cloud hosting and infrastructure services for secure data storage and processing.
                <a href="https://privacy.microsoft.com/en-us/privacystatement" target="_blank" rel="noopener noreferrer" class="text-green-600 hover:text-green-700 underline">Microsoft Privacy Statement</a>
              </li>
            </ul>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              These service providers are contractually obligated to protect your information and use it only for the purposes we specify.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">8. Data Retention</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy,
              unless a longer retention period is required or permitted by law. When we no longer need your personal information,
              we will securely delete or anonymize it.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">9. Your Privacy Rights</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              Depending on your location, you may have certain rights regarding your personal information:
            </p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 ml-4 mb-4">
              <li><strong>Access:</strong> Request access to your personal information</li>
              <li><strong>Correction:</strong> Request correction of inaccurate information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information</li>
              <li><strong>Portability:</strong> Request a copy of your data in a portable format</li>
              <li><strong>Opt-out:</strong> Opt-out of marketing communications</li>
            </ul>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              To exercise these rights, please contact us using the information provided in the "Contact Us" section.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">10. Children's Privacy</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              Our services are not intended for children under the age of 13. We do not knowingly collect personal information from children under 13.
              If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">11. International Data Transfers</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              Your information may be transferred to and processed in countries other than your own. We ensure that such transfers are conducted
              in accordance with applicable data protection laws and that appropriate safeguards are in place.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">12. Changes to This Privacy Policy</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page
              and updating the "Last updated" date. We encourage you to review this Privacy Policy periodically.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">13. Contact Us</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              If you have any questions about this Privacy Policy or our privacy practices, please contact us:
            </p>
            <div class="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-gray-700 dark:text-gray-300"><strong>Company:</strong> Wall St Yardie Inc</p>
              <p class="text-gray-700 dark:text-gray-300"><strong>Email:</strong> bossman&#64;wallstyardie.com</p>
              <p class="text-gray-700 dark:text-gray-300"><strong>Website:</strong> www.wallstyardie.com</p>
              <p class="text-gray-700 dark:text-gray-300"><strong>Address:</strong> 602 N University Dr., Pembroke Pines, FL 33024</p>
            </div>
          </section>

        </div>

        <div class="text-center mt-8">
          <a href="/" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 transition-colors">
            <i class="pi pi-arrow-left mr-2"></i>Back to Home
          </a>
        </div>

      </div>
    </div>
  }

  @case ('disclaimer') {
    <div class="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
      <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

        <div class="text-center mb-12">
          <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">Investment Disclaimer</h1>
          <p class="text-lg text-gray-600 dark:text-gray-400">Last updated: {{ lastUpdated() }}</p>
          <div class="mt-6 p-4 bg-red-50 border-l-4 border-red-400 rounded-r-lg">
            <div class="flex">
              <div class="flex-shrink-0">
                <i class="pi pi-exclamation-triangle text-red-400 text-xl"></i>
              </div>
              <div class="ml-3">
                <p class="text-sm text-red-700 font-semibold">
                  IMPORTANT: Please read this disclaimer carefully before using Wall St Yardie Inc services.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 space-y-8">

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Copyright Notice</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed font-semibold text-center p-4 rounded-lg">
              © 2025 Wall St Yardie Inc. All rights reserved.
            </p>
          </section>

          <section>
            <div class="bg-yellow-50 border-2 border-yellow-200 rounded-lg p-6 mb-6">
              <h2 class="text-2xl font-semibold text-yellow-800 mb-4 flex items-center">
                <i class="pi pi-exclamation-triangle mr-3 text-yellow-600"></i>
                NOT INVESTMENT ADVICE
              </h2>
              <div class="space-y-4 text-yellow-800">
                <p class="leading-relaxed font-semibold">
                  Neither Wall St Yardie Inc nor its subsidiaries, nor any of their respective officers, employees, representatives,
                  agents or independent contractors are, in such capacities, licensed financial advisors, registered investment
                  advisers or registered broker-dealers.
                </p>
                <p class="leading-relaxed font-semibold">
                  Wall St Yardie Inc does NOT provide investment or financial advice or make investment recommendations,
                  nor are we in the business of transacting trades.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Educational and Informational Purpose Only</h2>
            <div class="bg-blue-50 border-l-4 border-blue-400 p-6 mb-4">
              <p class="text-blue-800 leading-relaxed">
                <strong>All content on Wall St Yardie Inc is created, produced, and provided solely by Wall St Yardie Inc and is for
                informational and educational purposes only.</strong>
              </p>
            </div>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              Personal trading examples and analysis are for educational and demonstration purposes only.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              It is not, nor is it intended to be, trading or investment advice or as the basis for stock trades.
            </p>
          </section>

          <section>
            <div class="bg-red-50 border-2 border-red-200 rounded-lg p-6">
              <h2 class="text-2xl font-semibold text-red-800 mb-4 flex items-center">
                <i class="pi pi-ban mr-3 text-red-600"></i>
                NO BUY OR SELL RECOMMENDATIONS
              </h2>
              <div class="space-y-4 text-red-800">
                <p class="leading-relaxed font-semibold">
                  Neither the information nor any opinion expressed by Wall St Yardie Inc, or any of its affiliates constitutes
                  a solicitation or offer to buy or sell any securities, futures, or options, or other financial instruments.
                </p>
                <p class="leading-relaxed font-semibold">
                  Any prices, analysis, and opinions shared are our personal views and should NOT be interpreted as
                  investment advice or buy/sell recommendations.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Risk Assumption</h2>
            <div class="bg-orange-50 border-l-4 border-orange-400 p-6">
              <p class="text-orange-800 leading-relaxed font-semibold text-lg">
                You, the trader/investor, assume the entire risk as to the results and performance of any trading methods,
                strategies, or investments discussed on this website.
              </p>
            </div>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mt-4">
              Trading securities, futures products, and digital assets involve risk and may result in a loss greater than
              the original amount invested.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">No Warranties or Guarantees</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              The content on this website is provided by Wall St Yardie Inc and its third party content providers for your personal
              information only, and is not intended as investment advice or as the basis for stock trades.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              <strong>Wall St Yardie Inc EXPRESSLY DISCLAIMS ALL WARRANTIES, EXPRESSED OR IMPLIED, AS TO THE ACCURACY
              OF ANY THE CONTENT PROVIDED, OR AS TO THE FITNESS OF THE INFORMATION FOR ANY PURPOSE.</strong>
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Past Performance Disclaimer</h2>
            <div class="bg-purple-50 border-l-4 border-purple-400 p-6">
              <p class="text-purple-800 leading-relaxed font-semibold">
                Past performance is not indicative of future results. Performance is not presented net of all commissions,
                fees, and expenses.
              </p>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Seek Professional Advice</h2>
            <div class="bg-green-50 border-l-4 border-green-400 p-6">
              <p class="text-green-800 leading-relaxed">
                <strong>Before making any investment decisions, you should consult with a qualified financial advisor,
                registered investment adviser, or a registered broker-dealer.</strong>
              </p>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Limitation of Liability</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              Neither Wall St Yardie Inc nor its third party content providers shall be liable, and to the maximum extent permitted
              by law Wall St Yardie Inc hereby disclaims all liability, for errors, inaccuracies or delays in content, or for any
              actions taken in reliance thereon.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Contact Information</h2>
            <div class="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-gray-700 dark:text-gray-300"><strong>Email:</strong> bossman&#64;wallstyardie.com</p>
              <p class="text-gray-700 dark:text-gray-300"><strong>Website:</strong> www.wallstyardie.com</p>
            </div>
          </section>

          <section>
            <div class="bg-red-100 border-2 border-red-300 rounded-lg p-6">
              <h2 class="text-2xl font-semibold text-red-800 mb-4 text-center">⚠️ FINAL WARNING ⚠️</h2>
              <p class="text-red-800 leading-relaxed font-semibold text-center text-lg">
                INVESTING AND TRADING INVOLVES SUBSTANTIAL RISK OF LOSS AND IS NOT SUITABLE FOR EVERYONE.
                YOU SHOULD CAREFULLY CONSIDER WHETHER TRADING IS SUITABLE FOR YOU IN LIGHT OF YOUR CIRCUMSTANCES,
                KNOWLEDGE, AND FINANCIAL RESOURCES.
              </p>
            </div>
          </section>

        </div>

        <div class="text-center mt-8">
          <a href="/" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 transition-colors">
            <i class="pi pi-arrow-left mr-2"></i>Back to Home
          </a>
        </div>

      </div>
    </div>
  }

  @case ('cookies') {
    <div class="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
      <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

        <div class="text-center mb-12">
          <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">Cookie Policy</h1>
          <p class="text-lg text-gray-600 dark:text-gray-400">Last updated: {{ lastUpdated() }}</p>
        </div>

        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 space-y-8">

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">What Are Cookies?</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              Cookies are small text files that are placed on your computer or mobile device when you visit a website.
              They are widely used to make websites work more efficiently and to provide information to website owners.
            </p>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              Wall St Yardie Inc uses cookies to enhance your browsing experience, analyze site traffic, and personalize content.
            </p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Types of Cookies We Use</h2>
            <div class="space-y-6">
              <div class="border-l-4 border-blue-400 bg-blue-50 p-6">
                <h3 class="text-xl font-semibold text-blue-800 mb-3">Essential Cookies</h3>
                <p class="text-blue-700 leading-relaxed mb-3">
                  These cookies are necessary for the website to function properly.
                </p>
                <ul class="list-disc list-inside text-blue-700 space-y-1">
                  <li>Authentication and security cookies</li>
                  <li>Session management cookies</li>
                  <li>Load balancing cookies</li>
                  <li>User interface customization cookies</li>
                </ul>
              </div>
              <div class="border-l-4 border-green-400 bg-green-50 p-6">
                <h3 class="text-xl font-semibold text-green-800 mb-3">Analytics Cookies</h3>
                <p class="text-green-700 leading-relaxed mb-3">
                  These cookies help us understand how visitors interact with our website.
                </p>
                <ul class="list-disc list-inside text-green-700 space-y-1">
                  <li>Google Analytics cookies</li>
                  <li>Page view tracking cookies</li>
                  <li>User behavior analysis cookies</li>
                  <li>Performance monitoring cookies</li>
                </ul>
              </div>
              <div class="border-l-4 border-purple-400 bg-purple-50 p-6">
                <h3 class="text-xl font-semibold text-purple-800 mb-3">Functional Cookies</h3>
                <p class="text-purple-700 leading-relaxed mb-3">
                  These cookies enable enhanced functionality and personalization.
                </p>
                <ul class="list-disc list-inside text-purple-700 space-y-1">
                  <li>Language preference cookies</li>
                  <li>Theme and display preference cookies</li>
                  <li>Remember login information cookies</li>
                  <li>Personalized content cookies</li>
                </ul>
              </div>
              <div class="border-l-4 border-orange-400 bg-orange-50 p-6">
                <h3 class="text-xl font-semibold text-orange-800 mb-3">Marketing Cookies</h3>
                <p class="text-orange-700 leading-relaxed mb-3">
                  These cookies are used to deliver advertisements more relevant to you and your interests.
                </p>
                <ul class="list-disc list-inside text-orange-700 space-y-1">
                  <li>Advertising targeting cookies</li>
                  <li>Social media integration cookies</li>
                  <li>Remarketing cookies</li>
                  <li>Campaign tracking cookies</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Third-Party Cookies</h2>
            <div class="bg-gray-50 p-6 rounded-lg">
              <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-3">Third-Party Services We Use:</h3>
              <div class="grid md:grid-cols-2 gap-4">
                <div>
                  <h4 class="font-semibold text-gray-700 dark:text-gray-300 mb-2">Analytics</h4>
                  <ul class="text-gray-600 dark:text-gray-400 space-y-1">
                    <li>• Google Analytics</li>
                    <li>• Google Tag Manager</li>
                  </ul>
                </div>
                <div>
                  <h4 class="font-semibold text-gray-700 dark:text-gray-300 mb-2">Authentication</h4>
                  <ul class="text-gray-600 dark:text-gray-400 space-y-1">
                    <li>• Microsoft OAuth</li>
                    <li>• Google OAuth</li>
                    <li>• Apple OAuth</li>
                  </ul>
                </div>
                <div>
                  <h4 class="font-semibold text-gray-700 dark:text-gray-300 mb-2">Social Media</h4>
                  <ul class="text-gray-600 dark:text-gray-400 space-y-1">
                    <li>• Facebook Pixel</li>
                    <li>• Twitter Analytics</li>
                    <li>• LinkedIn Insights</li>
                  </ul>
                </div>
                <div>
                  <h4 class="font-semibold text-gray-700 dark:text-gray-300 mb-2">Communication</h4>
                  <ul class="text-gray-600 dark:text-gray-400 space-y-1">
                    <li>• Email service providers</li>
                    <li>• Customer support tools</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Cookie Duration</h2>
            <div class="grid md:grid-cols-2 gap-6">
              <div class="bg-blue-50 p-6 rounded-lg">
                <h3 class="text-lg font-semibold text-blue-800 mb-3">Session Cookies</h3>
                <p class="text-blue-700 leading-relaxed">
                  These cookies are temporary and are deleted when you close your browser.
                </p>
              </div>
              <div class="bg-green-50 p-6 rounded-lg">
                <h3 class="text-lg font-semibold text-green-800 mb-3">Persistent Cookies</h3>
                <p class="text-green-700 leading-relaxed">
                  These cookies remain on your device for a set period or until you delete them.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Managing Your Cookie Preferences</h2>
            <div class="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-6">
              <h3 class="text-lg font-semibold text-yellow-800 mb-3">Cookie Consent</h3>
              <p class="text-yellow-700 leading-relaxed">
                When you first visit our website, you'll see a cookie consent banner. You can choose to accept all cookies,
                reject non-essential cookies, or customize your preferences.
              </p>
            </div>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              You can control and manage cookies through your browser settings. Most browsers allow you to:
            </p>
            <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mb-6">
              <li>View what cookies are stored on your device</li>
              <li>Delete cookies individually or all at once</li>
              <li>Block cookies from specific websites</li>
              <li>Block all cookies</li>
              <li>Set preferences for different types of cookies</li>
            </ul>
            <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div class="bg-gray-50 p-4 rounded-lg text-center">
                <h4 class="font-semibold text-gray-800 mb-2">Chrome</h4>
                <p class="text-sm text-gray-600 dark:text-gray-400">Settings → Privacy and Security → Cookies</p>
              </div>
              <div class="bg-gray-50 p-4 rounded-lg text-center">
                <h4 class="font-semibold text-gray-800 mb-2">Firefox</h4>
                <p class="text-sm text-gray-600 dark:text-gray-400">Options → Privacy &amp; Security</p>
              </div>
              <div class="bg-gray-50 p-4 rounded-lg text-center">
                <h4 class="font-semibold text-gray-800 mb-2">Safari</h4>
                <p class="text-sm text-gray-600 dark:text-gray-400">Preferences → Privacy</p>
              </div>
              <div class="bg-gray-50 p-4 rounded-lg text-center">
                <h4 class="font-semibold text-gray-800 mb-2">Edge</h4>
                <p class="text-sm text-gray-600 dark:text-gray-400">Settings → Cookies and Site Permissions</p>
              </div>
            </div>
          </section>

          <section>
            <div class="bg-red-50 border-l-4 border-red-400 p-6">
              <h2 class="text-2xl font-semibold text-red-800 mb-4">Impact of Disabling Cookies</h2>
              <p class="text-red-700 leading-relaxed mb-4">Please note that disabling certain cookies may impact your experience on our website:</p>
              <ul class="list-disc list-inside text-red-700 space-y-2">
                <li>Some features may not work properly or at all</li>
                <li>You may need to re-enter information more frequently</li>
                <li>Personalized content and recommendations may not be available</li>
                <li>Website performance may be affected</li>
                <li>You may see less relevant advertisements</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Contact Us</h2>
            <div class="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-gray-700 dark:text-gray-300"><strong>Email:</strong> bossman&#64;wallstyardie.com</p>
              <p class="text-gray-700 dark:text-gray-300"><strong>Website:</strong> www.wallstyardie.com</p>
            </div>
          </section>

        </div>

        <div class="text-center mt-8">
          <a href="/" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 transition-colors">
            <i class="pi pi-arrow-left mr-2"></i>Back to Home
          </a>
        </div>

      </div>
    </div>
  }

  @case ('refund') {
    <div class="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
      <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

        <div class="text-center mb-12">
          <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">Refund Policy</h1>
          <p class="text-lg text-gray-600 dark:text-gray-400">Last updated: {{ lastUpdated() }}</p>
        </div>

        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 space-y-8">

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Our Commitment to Customer Satisfaction</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              At Wall St Yardie Inc, we are committed to providing high-quality investment research and educational content.
              We want you to be completely satisfied with your subscription.
            </p>
            <div class="bg-blue-50 border-l-4 border-blue-400 p-6">
              <p class="text-blue-800 leading-relaxed font-semibold">
                Please read this policy carefully before subscribing to any of our services. By subscribing, you agree to the terms outlined below.
              </p>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Subscription Types</h2>
            <div class="grid md:grid-cols-2 gap-6">
              <div class="bg-green-50 border border-green-200 rounded-lg p-6">
                <h3 class="text-xl font-semibold text-green-800 mb-3">Basic Plan</h3>
                <ul class="text-green-700 space-y-2">
                  <li>• Monthly subscription</li>
                  <li>• Basic stock analysis</li>
                  <li>• Educational content access</li>
                  <li>• Email support</li>
                </ul>
              </div>
              <div class="bg-blue-50 border border-blue-200 rounded-lg p-6">
                <h3 class="text-xl font-semibold text-blue-800 mb-3">Premium Plan</h3>
                <ul class="text-blue-700 space-y-2">
                  <li>• Monthly or annual subscription</li>
                  <li>• Advanced stock analysis</li>
                  <li>• Yardie's curated picks</li>
                  <li>• Priority support</li>
                  <li>• Exclusive tools and calculators</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Refund Eligibility</h2>
            <div class="space-y-6">
              <div class="bg-green-50 border-2 border-green-200 rounded-lg p-6">
                <h3 class="text-xl font-semibold text-green-800 mb-3 flex items-center">
                  <i class="pi pi-check-circle mr-3 text-green-600"></i>
                  30-Day Money-Back Guarantee
                </h3>
                <p class="text-green-700 leading-relaxed mb-4">
                  We offer a 30-day money-back guarantee for all new subscribers. If you are not satisfied with our service
                  within the first 30 days of your subscription, you may request a full refund.
                </p>
                <div class="bg-green-100 p-4 rounded-lg">
                  <h4 class="font-semibold text-green-800 mb-2">Conditions for 30-Day Refund:</h4>
                  <ul class="list-disc list-inside text-green-700 space-y-1">
                    <li>Request must be made within 30 days of initial subscription</li>
                    <li>Applies to first-time subscribers only</li>
                    <li>Account must not have been used for commercial purposes</li>
                    <li>No excessive downloading or data extraction</li>
                  </ul>
                </div>
              </div>
              <div class="bg-blue-50 border-2 border-blue-200 rounded-lg p-6">
                <h3 class="text-xl font-semibold text-blue-800 mb-3 flex items-center">
                  <i class="pi pi-calendar mr-3 text-blue-600"></i>
                  Prorated Refunds for Annual Subscriptions
                </h3>
                <p class="text-blue-700 leading-relaxed mb-4">
                  For annual subscriptions cancelled after the 30-day period, we may provide prorated refunds under specific circumstances:
                </p>
                <div class="bg-blue-100 p-4 rounded-lg">
                  <h4 class="font-semibold text-blue-800 mb-2">Eligible Circumstances:</h4>
                  <ul class="list-disc list-inside text-blue-700 space-y-1">
                    <li>Significant service disruption lasting more than 7 consecutive days</li>
                    <li>Major changes to service features that substantially reduce value</li>
                    <li>Technical issues preventing access for extended periods</li>
                    <li>Billing errors or unauthorized charges</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div class="bg-red-50 border-2 border-red-200 rounded-lg p-6">
              <h2 class="text-2xl font-semibold text-red-800 mb-4 flex items-center">
                <i class="pi pi-times-circle mr-3 text-red-600"></i>
                Non-Refundable Situations
              </h2>
              <p class="text-red-700 leading-relaxed mb-4">Refunds will not be provided in the following situations:</p>
              <ul class="list-disc list-inside text-red-700 space-y-2">
                <li>Subscription cancellation after the 30-day guarantee period (monthly plans)</li>
                <li>Failure to cancel before automatic renewal</li>
                <li>Violation of our Terms of Service</li>
                <li>Use of the service for commercial redistribution</li>
                <li>Excessive downloading or data extraction</li>
                <li>Account sharing or unauthorized access</li>
                <li>Investment losses based on information from our platform</li>
                <li>Change of mind after the guarantee period</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">How to Request a Refund</h2>
            <div class="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-6">
              <h3 class="text-lg font-semibold text-yellow-800 mb-3">Step-by-Step Process</h3>
              <ol class="list-decimal list-inside text-yellow-700 space-y-2">
                <li>Contact our customer support team via email</li>
                <li>Provide your account information and subscription details</li>
                <li>Explain the reason for your refund request</li>
                <li>Allow 3-5 business days for review and processing</li>
                <li>Receive confirmation and refund timeline</li>
              </ol>
            </div>
            <div class="grid md:grid-cols-2 gap-6">
              <div class="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-3">Contact Information</h3>
                <div class="space-y-2">
                  <p class="text-gray-700 dark:text-gray-300"><strong>Email:</strong> bossman&#64;wallstyardie.com</p>
                  <p class="text-gray-700 dark:text-gray-300"><strong>Subject Line:</strong> "Refund Request - [Your Account Email]"</p>
                  <p class="text-gray-700 dark:text-gray-300"><strong>Response Time:</strong> Within 24 hours</p>
                </div>
              </div>
              <div class="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-3">Required Information</h3>
                <ul class="text-gray-700 dark:text-gray-300 space-y-1">
                  <li>• Account email address</li>
                  <li>• Subscription start date</li>
                  <li>• Reason for refund request</li>
                  <li>• Transaction ID (if available)</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Refund Processing Timeline</h2>
            <div class="bg-purple-50 border border-purple-200 rounded-lg p-6">
              <div class="grid md:grid-cols-3 gap-6 text-center">
                <div>
                  <div class="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                    <span class="text-2xl font-bold text-purple-600">1</span>
                  </div>
                  <h3 class="font-semibold text-purple-800 mb-2">Review</h3>
                  <p class="text-purple-700 text-sm">1-3 business days for request review and approval</p>
                </div>
                <div>
                  <div class="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                    <span class="text-2xl font-bold text-purple-600">2</span>
                  </div>
                  <h3 class="font-semibold text-purple-800 mb-2">Processing</h3>
                  <p class="text-purple-700 text-sm">2-5 business days for payment processor handling</p>
                </div>
                <div>
                  <div class="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                    <span class="text-2xl font-bold text-purple-600">3</span>
                  </div>
                  <h3 class="font-semibold text-purple-800 mb-2">Completion</h3>
                  <p class="text-purple-700 text-sm">3-10 business days for funds to appear in your account</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Customer Support</h2>
            <div class="p-6 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <div class="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 class="font-semibold text-gray-800 dark:text-white mb-3">Contact Information</h3>
                  <div class="space-y-2">
                    <p class="text-gray-700 dark:text-gray-300"><strong>Email:</strong> bossman&#64;wallstyardie.com</p>
                    <p class="text-gray-700 dark:text-gray-300"><strong>Response Time:</strong> Within 24 hours</p>
                    <p class="text-gray-700 dark:text-gray-300"><strong>Business Hours:</strong> Monday - Friday, 9 AM - 6 PM EST</p>
                  </div>
                </div>
                <div>
                  <h3 class="font-semibold text-gray-800 dark:text-white mb-3">What to Include</h3>
                  <ul class="text-gray-700 dark:text-gray-300 space-y-1">
                    <li>• Your account email address</li>
                    <li>• Detailed description of the issue</li>
                    <li>• Screenshots if applicable</li>
                    <li>• Transaction IDs or reference numbers</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Changes to This Policy</h2>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
              We may update this Refund Policy from time to time to reflect changes in our services or business practices.
              Any changes will be posted on this page with an updated "Last modified" date.
            </p>
          </section>

        </div>

        <div class="text-center mt-8">
          <a href="/" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 transition-colors">
            <i class="pi pi-arrow-left mr-2"></i>Back to Home
          </a>
        </div>

      </div>
    </div>
  }
}
